// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
/**
 * An implementation of mermaid fenced code blocks in markdown.
 */
export class MermaidMarkdown {
    constructor(options) {
        this.languages = ['mermaid'];
        this.rank = 100;
        this._mermaid = options.mermaid;
    }
    /**
     * Pre-parse and cache the rendered text.
     */
    async walk(text) {
        await this._mermaid.renderFigure(text);
    }
    /**
     * Render the diagram.
     */
    render(text) {
        // handle pre-cached mermaid figures
        let cachedFigure = this._mermaid.getCachedFigure(text);
        if (cachedFigure) {
            return cachedFigure.outerHTML;
        }
        return null;
    }
}
//# sourceMappingURL=markdown.js.map